import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";

var _window;

import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";
import { getDay } from 'date-fns';
import Wrapper from '../wrapper/Wrapper';
import Heading from '../heading/Heading';
import LocationCard from '../location/Card';
import Separator from '../separator/Separator';
import ImageLoader from '../images/ImageLoader';
import LoadScript from "react-load-script";
import { Container, Row, Col, Button } from 'react-bootstrap';
import storeService1Img from '../../images/sample-content/Mommas_Pancake_Breakfast_780x390.jpg';
import storeService2Img from '../../images/sample-content/Four-Layer-Bkfst-Bowl-Bundle_780x390.jpg';
import storeService3Img from '../../images/sample-content/Homestyle-Chicken-BLT_780x390.jpg';
import storeService4Img from '../../images/sample-content/front_porch_dining_780x390.jpg';
import media1Img from '../../images/sample-content/Catering_CnD_Meatloaf_780x390.jpg';
import media2Img from '../../images/sample-content/Grandmas-Sampler_780x390.jpg';
import storeImg from '../../images/sample-content/store.jpg';
import map2Img from '../../images/sample-content/Wichita_(Park_City)_map.png';
import differenceInMilliseconds from 'date-fns/differenceInMilliseconds';
import MetaTags from 'react-meta-tags';
import bluePin from '../../images/blue-pin.png';
import { mobileAppUtil, locationUtil } from '../../util';
import { waitlistDuck } from "../../ducks/waitlist";
import WaitlistForm from '../forms/Waitlist';
import gaTracker from '../../util/ga-analytics/gaTracker';
import Modal from '../modal/Modal';
var waitListOperations = waitlistDuck.operations;
import * as UTIL from '../../util'; //MediaQuery

import MediaQuery from 'react-responsive';
export var staticJSS = {
  "uid": "3a7b99c5-f64b-4e21-ac7c-510519158726",
  "componentName": "LocationDetail",
  "dataSource": "",
  "fields": {
    "model": {
      "aboutUsDescription": "",
      "address1": "4630 Sierra College Blvd.",
      "address2": "",
      "alternateName": "Rocklin",
      "avgWaitTime": "6 minutes",
      "beerWine": "",
      "careers": "",
      "catering": false,
      "cateringDelivery": false,
      "cateringDeliveryAvailable": false,
      "cateringDeliveryLaunchDate": "0001-01-01T00:00:00",
      "cateringMenu": false,
      "city": "Rocklin",
      "companyUid": "",
      "country": "US",
      "curbside": false,
      "dineIn": true,
      "dispatchIndividual": false,
      "englishBreakfast": "https://crackerbarrel.com/menupdfs/STORE_756_BK_MENU_EN.pdf",
      "englishLunchDinner": "",
      "facebookPage": "https://www.facebook.com/crackerbarrel.rocklin",
      "familyValueMeals": false,
      "featuredMenu": "",
      "fridayClose": "10:00 PM",
      "fridayOpen": "7:00 AM",
      "frontPorchDining": false,
      "ghostKitchen": false,
      "holidayHns": false,
      "individualMeals": true,
      "integratedCateringDelivery": false,
      "localPageImage1": "",
      "localPageImage2": "",
      "localPageImage3": "",
      "maxLiveDate": "0001-01-01T00:00:00",
      "mondayClose": "9:00 PM",
      "mondayOpen": "8:00 AM",
      "name": "Cracker Barrel",
      "nowOpen": "1",
      "oloCateringUniqueName": "rocklin-ca-catering",
      "oloStore": true,
      "oloUniqueName": "rocklin-ca",
      "onlineOrdering": false,
      "openingSoon": false,
      "park": false,
      "payInApp": false,
      "phone": "916-652-0103",
      "pickUp": false,
      "posSystem": "",
      "saturdayClose": "10:00 PM",
      "saturdayOpen": "7:00 AM",
      "spanishBreakfast": "https://crackerbarrel.com/menupdfs/STORE_756_BK_MENU_EN.pdf",
      "spanishLunchDinner": "https://crackerbarrel.com/menupdfs/STORE_756_LD_MENU_ES.pdf",
      "specialHours": "",
      "specialNotes": "This location is now offering dine-in service in compliance with state and local guidelines for a safe COVID-19 reopening. Curbside, Pickup & Delivery also available.​",
      "state": "CA",
      "storeId": "2fbf1cc8-fa45-46d0-b13d-01f8801cf1d8",
      "storeNumber": "756",
      "sundayClose": "9:00 PM",
      "sundayOpen": "7:00 AM",
      "temporarilyClosed": false,
      "thursdayClose": "",
      "thursdayOpen": "8:00 AM",
      "tuesdayClose": "9:00 PM",
      "tuesdayOpen": "8:00 AM",
      "vendorId": "88894",
      "vendorIdCatering": "88896",
      "waitlist": true,
      "webAheadStatus": "Available",
      "wednesdayClose": "9:00 PM",
      "wednesdayOpen": "8:00 AM",
      "yelpReOpenDate": "0001-01-01T00:00:00",
      "zip": "95677",
      "latitude": "38.7995198",
      "longitude": "-121.2085361",
      "detailLink": "/Locations/States/ca/rocklin/756"
    },
    "nearbyLocations": []
  }
};

var handlePreferred = function handlePreferred() {
  alert('Triggered preferred ');
};

var width = typeof window !== 'undefined' ? (_window = window) === null || _window === void 0 ? void 0 : _window.innerWidth : {};
var storeService1 = {
  'value': {
    'src': storeService1Img,
    'alt': 'Holiday Heat n\' Serve',
    'title': 'Holiday Heat n\' Serve',
    'width': '94px',
    'height': '47px'
  }
};
var storeService2 = {
  'value': {
    'src': storeService2Img,
    'alt': 'Holiday Heat n\' Serve',
    'title': 'Holiday Heat n\' Serve',
    'width': '94px',
    'height': '47px'
  }
};
var storeService3 = {
  'value': {
    'src': storeService3Img,
    'alt': 'Holiday Heat n\' Serve',
    'title': 'Holiday Heat n\' Serve',
    'width': '94px',
    'height': '47px'
  }
};
var storeService4 = {
  'value': {
    'src': storeService4Img,
    'alt': 'Front Porch Dining',
    'title': 'Front Porch Dining',
    'width': '94px',
    'height': '47px'
  }
};
var media1 = {
  'value': {
    'src': media1Img,
    'alt': 'Holiday Heat n\' Serve',
    'title': 'Holiday Heat n\' Serve',
    'width': '185px',
    'height': '93px'
  }
};
var media2 = {
  'value': {
    'src': media2Img,
    'alt': 'Holiday Heat n\' Serve',
    'title': 'Holiday Heat n\' Serve',
    'width': '185px',
    'height': '93px'
  }
};
var mobileMedia1 = {
  'value': {
    'src': '/images/sample-content/Catering_CnD_Meatloaf_780x390.jpg',
    'alt': 'Holiday Heat n\' Serve',
    'title': 'Holiday Heat n\' Serve',
    'width': '350px',
    'height': '233px'
  }
};
var mobileMedia2 = {
  'value': {
    'src': '/images/sample-content/Grandmas-Sampler_780x390.jpg',
    'alt': 'Holiday Heat n\' Serve',
    'title': 'Holiday Heat n\' Serve',
    'width': '350px',
    'height': '233px'
  }
};
var mediaStore = {
  'value': {
    'src': storeImg,
    'alt': 'Holiday Heat n\' Serve',
    'title': 'Holiday Heat n\' Serve',
    'width': '700px',
    'height': '467px'
  }
};
var storeSmall = {
  'value': {
    'src': '/images/sample-content/store.jpg',
    'alt': 'Holiday Heat n\' Serve',
    'title': 'Holiday Heat n\' Serve',
    'width': '350px',
    'height': '233px'
  }
};
var map2 = {
  'value': {
    'src': map2Img,
    'alt': 'Holiday Heat n\' Serve',
    'title': 'Holiday Heat n\' Serve',
    'width': '324px',
    'height': '500px'
  }
};
export var LocationDetail = function LocationDetail(props) {
  var fields = props.fields,
      _props$store = props.store,
      store = _props$store === void 0 ? {} : _props$store,
      _props$setLocation = props.setLocation,
      setLocation = _props$setLocation === void 0 ? function () {
    return "";
  } : _props$setLocation,
      location = props.location,
      showForm = props.showForm,
      waitlistConfirmation = props.waitlistConfirmation,
      waitlistLoading = props.waitlistLoading,
      waitlistActive = props.waitlistActive,
      isError = props.isError,
      results = props.results,
      _props$toggleWaitlist = props.toggleWaitlist,
      toggleWaitlist = _props$toggleWaitlist === void 0 ? toggleWaitlist : _props$toggleWaitlist;

  var _ref = fields || staticJSS.fields || {},
      model = _ref.model,
      _ref$nearbyLocations = _ref.nearbyLocations,
      nearbyLocations = _ref$nearbyLocations === void 0 ? [] : _ref$nearbyLocations;

  var jssInfo = model || staticJSS.fields.model || {};

  var getLocation = function getLocation(data, callback) {
    return waitListOperations.setWaitlistAvailableQSR(data, callback);
  };

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      waitTime = _useState2[0],
      setWaitTime = _useState2[1];

  useEffect(function () {
    getLocation(jssInfo.storeId, setWaitTime);
  }, []);
  var locMap, nearbyMap, popup, dataSource, iconLayer, centerMarker, searchURL;
  var iconPinUrl = bluePin;
  var userLocation;
  var userLocationData;
  var features = [];
  var mapLocMarker, mapNearbyMarker;
  var azureKey = 'HC0Foayx7EcpPWXp6zqwA4Nmce5OmcuI4_AbhRrgjyE';

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      mapControlScript = _useState4[0],
      setmapControlScript = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      mapServiceScript = _useState6[0],
      setmapServiceScript = _useState6[1];

  var history = useHistory();

  var handleMapControlScript = function handleMapControlScript() {
    setmapControlScript(true);
  };

  var handleMapServiceScript = function handleMapServiceScript() {
    setmapServiceScript(true);
  };

  var initMap = function initMap() {
    if (mapServiceScript && mapControlScript) {
      locMap = new atlas.Map('myMap', {
        center: [parseFloat(jssInfo.longitude), parseFloat(jssInfo.latitude)],
        zoom: 10,
        language: 'en-US',
        view: 'Auto',
        style: "road",
        authOptions: {
          authType: 'subscriptionKey',
          subscriptionKey: azureKey
        }
      });
      locMap.events.add('ready', function () {
        locMap.controls.add(new atlas.control.ZoomControl(), {
          position: 'top-right'
        });
        addPin();
      });

      if (Array.isArray(nearbyLocations) && nearbyLocations.length) {
        var _nearbyLocations$, _nearbyLocations$2;

        nearbyMap = new atlas.Map('nearbyMap', {
          center: [parseFloat(((_nearbyLocations$ = nearbyLocations[0]) === null || _nearbyLocations$ === void 0 ? void 0 : _nearbyLocations$.longitude) || 0), parseFloat(((_nearbyLocations$2 = nearbyLocations[0]) === null || _nearbyLocations$2 === void 0 ? void 0 : _nearbyLocations$2.latitude) || 0)],
          zoom: 8,
          language: 'en-US',
          view: 'Auto',
          style: "road",
          authOptions: {
            authType: 'subscriptionKey',
            subscriptionKey: azureKey
          }
        });
        nearbyMap.events.add('ready', function () {
          var dataSource = new atlas.source.DataSource();
          nearbyMap.sources.add(dataSource);
          nearbyMap.controls.add(new atlas.control.ZoomControl(), {
            position: 'top-right'
          });
          addNearbyPin(dataSource);
        });
      }
    }
  };

  useEffect(function () {
    initMap();
  }, [mapControlScript, mapServiceScript, model]);

  var addPin = function addPin() {
    mapLocMarker = new atlas.HtmlMarker({
      htmlContent: '<svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" class="cb-location-banner__icon cb-color-blue-500" height="2.25em" width="2.25em" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"></path></svg>',
      position: [parseFloat(jssInfo.longitude), parseFloat(jssInfo.latitude)]
    });
    locMap.markers.add(mapLocMarker);
  };

  var addNearbyPin = function addNearbyPin(dataSource) {
    var features = [];

    for (var i = 0; i < nearbyLocations.length; i++) {
      var _nearbyLocations$i, _nearbyLocations$i2, _nearbyLocations$i3;

      //console.log(locationData[i].companyUid);
      features.push(new atlas.data.Feature(new atlas.data.Point([parseFloat((_nearbyLocations$i = nearbyLocations[i]) === null || _nearbyLocations$i === void 0 ? void 0 : _nearbyLocations$i.longitude), parseFloat((_nearbyLocations$i2 = nearbyLocations[i]) === null || _nearbyLocations$i2 === void 0 ? void 0 : _nearbyLocations$i2.latitude)]), {
        companyUid: (_nearbyLocations$i3 = nearbyLocations[i]) === null || _nearbyLocations$i3 === void 0 ? void 0 : _nearbyLocations$i3.CompanyUid,
        index: i
      }));
    } // console.log(features, "FEATURES")


    dataSource.add(new atlas.data.FeatureCollection(features)); //Load a custom image icon into the map resources.

    nearbyMap.imageSprite.add('myCustomIcon', iconPinUrl).then(function () {
      //Create a layer to render a coffee cup symbol above each bubble for an individual location.
      iconLayer = new atlas.layer.SymbolLayer(dataSource, null, {
        iconOptions: {
          //Pass in the ID of the custom icon that was loaded into the map resources.
          image: 'myCustomIcon',
          //Optionally, scale the size of the icon.
          font: ['SegoeUi-Bold'],
          //Anchor the center of the icon image to the coordinate.
          anchor: 'center',
          //Allow the icons to overlap.
          allowOverlap: true
        },
        filter: ['!', ['has', 'point_count']] //Filter out clustered points from this layer.

      });
      nearbyMap.layers.add(iconLayer);
    });
  };

  var setStore = function setStore(store, redirectUrl) {
    var locationIds = UTIL.locationIdsUrl();
    setLocation(store, Object.keys(locationIds).length ? locationIds.retaincart : "false");

    if (redirectUrl != "") {
      history.push(redirectUrl);
    }
  };

  var ga = function ga() {
    var data = {
      gtm: {
        uniqueEventId: '25',
        elementId: "banner-joinwaitlist"
      },
      event: 'gtm.click'
    };
    gaTracker(data);
  };

  var handleWaitlistModal = function handleWaitlistModal() {
    ga();
    toggleWaitlist(true);
  };

  var handleClose = function handleClose() {
    toggleWaitlist();
  };

  var waitListTitle = showForm ? "Join the Wait List" : "";
  var prefix = mobileAppUtil.isMobileApp() ? '' : 'https://www.crackerbarrel.com'; // TODO :: need a better solution

  var storeServiceURLs = {
    "toGo": "/menu",
    "catering": "/catering",
    "curbside": "/menu/?vendorid=" + jssInfo.vendorId,
    "waitList": "/menu/?vendorid=" + jssInfo.vendorId + "&action=getonlist"
  };
  var menuURLs = {
    "breakfast": prefix + "/menupdfs/STORE_" + jssInfo.storeNumber + "_BK_MENU_EN.pdf",
    "lunchNdinner": prefix + "/menupdfs/STORE_" + jssInfo.storeNumber + "_LD_MENU_EN.pdf",
    "featured": prefix + "/menupdfs/STORE_" + jssInfo.storeNumber + "_FTR_MENU.pdf",
    "beerNwine": prefix + "/menupdfs/STORE_" + jssInfo.storeNumber + "_ALC_MENU.pdf"
  };
  var generatedurl = jssInfo.facebookPage ? jssInfo.facebookPage.replace(/\//g, '%2F').replace(/:/g, '%3A') : "https://www.facebook.com/crackerbarrel/".replace(/\//g, '%2F').replace(/:/g, '%3A');
  var facebookLike = "https://www.facebook.com/plugins/like.php?href=" + generatedurl + "&width=60&layout=button&action=like&size=small&share=false&height=65&appId";
  var openJobs = "https://careers-crackerbarrel.icims.com/jobs/search?ics_geolocation=" + jssInfo.city + "%2C%20" + jssInfo.state + "%2C%20" + jssInfo.country;
  var openJobsURL = openJobs.replace(/\s/g, '%20');
  var isWaitListAvailable = locationUtil.isWaitListAvailable(jssInfo); // const test = locationOperations.getLocationWaitTime()

  return /*#__PURE__*/React.createElement(Container, {
    className: "cb-location-detail--container"
  }, /*#__PURE__*/React.createElement(Modal, {
    show: waitlistActive,
    hide: handleClose,
    title: waitListTitle
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(WaitlistForm, {
    store: store,
    location: location,
    results: results,
    confirmation: waitlistConfirmation,
    isLoading: waitlistLoading,
    isError: isError
  }))), /*#__PURE__*/React.createElement(MetaTags, null, Boolean(jssInfo.alternateName) && /*#__PURE__*/React.createElement("title", null, jssInfo.alternateName)), /*#__PURE__*/React.createElement(Wrapper, {
    layout: {
      padding: "medium"
    },
    className: ""
  }, /*#__PURE__*/React.createElement(Row, {
    className: "row-grid"
  }, /*#__PURE__*/React.createElement(Col, {
    lg: "5"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "cb-type-subheading-1 cb-color-red-900"
  }, "BREAKFAST, LUNCH, AND DINNER IN ", jssInfo.city, ", ", jssInfo.state), /*#__PURE__*/React.createElement("h1", {
    className: "cb-type-display-1 cb-color-red-900"
  }, "Cracker Barrel in ", jssInfo.alternateName), /*#__PURE__*/React.createElement(LocationCard, {
    data: jssInfo,
    handlePreferred: handlePreferred
  }), /*#__PURE__*/React.createElement("p", {
    className: "cb-location-detail__notes"
  }, jssInfo.specialNotes), /*#__PURE__*/React.createElement("br", null), !jssInfo.temporarilyClosed && /*#__PURE__*/React.createElement(Row, {
    className: "row-grid w-100"
  }, /*#__PURE__*/React.createElement(Col, {
    xs: "6",
    lg: {
      span: 4,
      order: 2
    }
  }, /*#__PURE__*/React.createElement(Button, {
    className: "cb-button-primary cb-button-thin",
    onClick: function onClick() {
      return setStore(jssInfo, storeServiceURLs.catering);
    }
  }, /*#__PURE__*/React.createElement(Heading, {
    field: {
      value: 'Order Catering'
    },
    level: "3"
  }))), /*#__PURE__*/React.createElement(Col, {
    xs: "6",
    lg: {
      span: 4,
      order: 3
    }
  }, /*#__PURE__*/React.createElement(Button, {
    className: "cb-button-primary cb-button-thin",
    onClick: function onClick() {
      return setStore(jssInfo, storeServiceURLs.toGo);
    }
  }, /*#__PURE__*/React.createElement(Heading, {
    field: {
      value: 'Order To-Go'
    },
    level: "3"
  }))), jssInfo.waitlist && isWaitListAvailable && (waitTime === null || waitTime === void 0 ? void 0 : waitTime.Quote) && /*#__PURE__*/React.createElement(Col, {
    xs: "12",
    lg: {
      span: 4,
      order: 1
    },
    className: "cb-location-detail__waitlist-button"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "cb-button-secondary cb-button-thin",
    onClick: function onClick() {
      setStore(jssInfo, "");
      handleWaitlistModal();
    }
  }, /*#__PURE__*/React.createElement(Heading, {
    field: {
      value: 'Join Wait List'
    },
    level: "3"
  }), /*#__PURE__*/React.createElement(Heading, {
    className: "cb-type-body-1",
    field: {
      value: waitTime ? waitTime.Quote.ConsumerQuoteString.replace('About ', '').split(' ')[0] + ' min wait' : ' min wait'
    },
    level: "3"
  }))))), /*#__PURE__*/React.createElement(Col, {
    lg: "7"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    id: "myMap",
    style: {
      height: 400 + 'px'
    }
  }), /*#__PURE__*/React.createElement(LoadScript, {
    url: "https://atlas.microsoft.com/sdk/javascript/mapcontrol/2/atlas.min.js",
    onLoad: handleMapControlScript
  }), /*#__PURE__*/React.createElement(LoadScript, {
    url: "https://atlas.microsoft.com/sdk/javascript/service/2/atlas-service.min.js",
    onLoad: handleMapServiceScript
  })))), /*#__PURE__*/React.createElement("div", {
    className: "cb-article-list__separator"
  }), /*#__PURE__*/React.createElement(Row, {
    className: "row-grid"
  }, /*#__PURE__*/React.createElement(Col, {
    xs: "12",
    lg: {
      span: 5,
      order: 1
    }
  }, /*#__PURE__*/React.createElement("h2", {
    "aria-level": "2",
    className: "cb-type-headline-1 cb-color-red-900"
  }, "STORE HOURS", jssInfo.temporarilyClosed && /*#__PURE__*/React.createElement("span", null, " - TEMPORARILY CLOSED"), " "), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(TimeDisplay, {
    num: 1,
    name: "Monday: ",
    times: jssInfo.mondayOpen && jssInfo.mondayClose ? "".concat(jssInfo.mondayOpen, " - ").concat(jssInfo.mondayClose) : "Closed"
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(TimeDisplay, {
    num: 2,
    name: "Tuesday: ",
    times: jssInfo.tuesdayOpen && jssInfo.tuesdayClose ? "".concat(jssInfo.tuesdayOpen, " - ").concat(jssInfo.tuesdayClose) : "Closed"
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(TimeDisplay, {
    num: 3,
    name: "Wednesday: ",
    times: jssInfo.wednesdayOpen && jssInfo.wednesdayClose ? "".concat(jssInfo.wednesdayOpen, " - ").concat(jssInfo.wednesdayClose) : "Closed"
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(TimeDisplay, {
    num: 4,
    name: "Thursday: ",
    times: jssInfo.thursdayOpen && jssInfo.thursdayClose ? "".concat(jssInfo.thursdayOpen, " - ").concat(jssInfo.thursdayClose) : "Closed"
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(TimeDisplay, {
    num: 5,
    name: "Friday: ",
    times: jssInfo.fridayOpen && jssInfo.fridayClose ? "".concat(jssInfo.fridayOpen, " - ").concat(jssInfo.fridayClose) : "Closed"
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(TimeDisplay, {
    num: 6,
    name: "Saturday: ",
    times: jssInfo.saturdayOpen && jssInfo.saturdayClose ? "".concat(jssInfo.saturdayOpen, " - ").concat(jssInfo.saturdayClose) : "Closed"
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(TimeDisplay, {
    num: 0,
    name: "Sunday: ",
    times: jssInfo.sundayOpen && jssInfo.sundayClose ? "".concat(jssInfo.sundayOpen, " - ").concat(jssInfo.sundayClose) : "Closed"
  }), /*#__PURE__*/React.createElement(Separator, {
    background: "default",
    display: "solid",
    image: true,
    padding: "medium"
  })), /*#__PURE__*/React.createElement(Col, {
    xs: "12",
    lg: {
      span: 7,
      order: 2
    }
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    lg: "12",
    xs: "12"
  }, /*#__PURE__*/React.createElement("h2", {
    "aria-level": "2",
    className: "cb-type-headline-1 cb-color-red-900"
  }, "Cracker Barrel Catering\xAE"))), /*#__PURE__*/React.createElement(Row, {
    className: "mt-16"
  }, /*#__PURE__*/React.createElement(Col, {
    className: width < 576 ? "d-flex justify-content-center" : "",
    xs: "12",
    lg: {
      span: 3,
      order: 2
    }
  }, /*#__PURE__*/React.createElement(ImageLoader, {
    media: width > 576 ? media1 : mobileMedia1,
    className: "cb-location-detail__image"
  })), /*#__PURE__*/React.createElement(Col, {
    xs: "12",
    lg: {
      span: 9,
      order: 3
    }
  }, /*#__PURE__*/React.createElement("p", {
    className: "cb-type-title-2 cb-color-red-900"
  }, "Corporate event, networking function, wedding, barbeque or picnic - it doesn\u2019t matter what your next big gathering is, we\u2019ve got you covered with Cracker Barrel Catering. Tell us all about your event and we\u2019ll take care of the rest, so your meal goes off without a hitch."))), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    className: "d-flex justify-content-center"
  }, /*#__PURE__*/React.createElement(Button, {
    className: "cb-button-primary",
    href: "https://www.crackerbarrel.com/catering"
  }, "Learn More"))), width > 576 ? /*#__PURE__*/React.createElement(Separator, {
    background: "default",
    display: "solid",
    image: true,
    padding: "medium"
  }) : /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement(Col, {
    xs: "12",
    lg: {
      span: 5,
      order: 3
    }
  }, /*#__PURE__*/React.createElement("h2", {
    "aria-level": "2",
    className: "cb-type-headline-1 cb-color-red-900"
  }, "STORE SERVICES"), /*#__PURE__*/React.createElement("div", {
    className: "mt-16"
  }), jssInfo.pickUp && /*#__PURE__*/React.createElement(Service, {
    href: storeServiceURLs.toGo,
    media: storeService1,
    heading: "Carry-Out ".concat(jssInfo.dispatchIndividual && !jssInfo.temporarilyClosed ? "(Delivery Available)" : ""),
    Available: jssInfo.pickUp,
    body: "Enjoy your favorite breakfast or comfort food wherever you like. Order Cracker Barrel To-Go."
  }), jssInfo.catering && /*#__PURE__*/React.createElement(Service, {
    href: storeServiceURLs.catering,
    media: storeService2,
    heading: "Order Catering ".concat(jssInfo.dispatchIndividual && !jssInfo.temporarilyClosed ? "(Delivery Available)" : ""),
    Available: jssInfo.catering,
    body: "Satisfy any crowd with Cracker Barrel Catering. Simply order online, serve and enjoy."
  }), jssInfo.curbside && /*#__PURE__*/React.createElement(Service, {
    href: storeServiceURLs.curbside,
    media: storeService3,
    heading: "Curbside",
    Available: jssInfo.curbside,
    body: "Park in reserved To-Go Parking and call the number on the sign. We’ll bring your order to you."
  }), jssInfo.frontPorchDining && /*#__PURE__*/React.createElement(Service, {
    media: storeService4,
    heading: "Front Porch Dining",
    Available: jssInfo.frontPorchDining,
    body: "Dine in with us for breakfast, lunch, or dinner and enjoy your favorites from our front porch seating."
  }), jssInfo.park || jssInfo.payInApp ? /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    lg: "2"
  }), /*#__PURE__*/React.createElement(Col, {
    sm: "12",
    lg: "10"
  }, /*#__PURE__*/React.createElement("h2", {
    "aria-level": "2",
    className: "cb-type-subheading-1 cb-color-red-900"
  }, "Amenities"), jssInfo.park ? /*#__PURE__*/React.createElement("p", {
    className: "cb-type-title-2 cb-color-red-900"
  }, "Bus/RV Accessible") : null, jssInfo.payInApp ? /*#__PURE__*/React.createElement("p", {
    className: "cb-type-title-2 cb-color-red-900"
  }, "Pay in App") : null)) : null, /*#__PURE__*/React.createElement(Separator, {
    background: "default",
    display: "solid",
    image: true,
    padding: "medium"
  })), /*#__PURE__*/React.createElement(Col, {
    xs: "12",
    lg: {
      span: 7,
      order: 6
    },
    className: width > 896 ? "cb-column-gap-reduction-medium" : ""
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    className: "d-flex justify-content-center",
    xs: "12",
    lg: {
      span: 12,
      order: 3
    },
    style: {
      overflowX: "hidden"
    }
  }, /*#__PURE__*/React.createElement(MediaQuery, {
    minWidth: 991
  }, /*#__PURE__*/React.createElement(ImageLoader, {
    media: mediaStore,
    className: "cb-location-detail__image"
  })), /*#__PURE__*/React.createElement(MediaQuery, {
    maxWidth: 990
  }, /*#__PURE__*/React.createElement(ImageLoader, {
    media: storeSmall,
    className: "cb-location-detail__image"
  }))), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Col, {
    xs: "12",
    lg: {
      span: 12,
      order: 1
    }
  }, /*#__PURE__*/React.createElement("h2", {
    "aria-level": "2",
    className: "cb-type-headline-1 cb-color-red-900"
  }, "About CRACKER BARREL ", jssInfo.alternateName)), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Col, {
    xs: "12",
    lg: {
      span: 12,
      order: 2
    },
    className: "mt-16"
  }, /*#__PURE__*/React.createElement("p", {
    className: "cb-type-title-2 cb-color-red-900"
  }, "Breakfast in ", jssInfo.city, ", ", jssInfo.state, " wouldn't be complete without Cracker Barrel's delicious homestyle food. Our all-day breakfast, lunch, and dinner menus allow you to get your fill of comfort food in our friendly ", jssInfo.state, " location. Shop throughout the country store, take a seat by the fire, or play some checkers while you wait for your meal to arrive - all with Cracker Barrel. For the best southern cooking in ", jssInfo.city, ", ", jssInfo.state, ", take a seat at our table."), /*#__PURE__*/React.createElement("p", null, "\xA0")))), /*#__PURE__*/React.createElement(Col, {
    xs: "0",
    lg: {
      span: 5,
      order: 7
    }
  }), /*#__PURE__*/React.createElement(Col, {
    xs: "12",
    lg: {
      span: 7,
      order: 8
    }
  }, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: "12",
    lg: {
      span: 12,
      order: 1
    }
  }, /*#__PURE__*/React.createElement("h2", {
    "aria-level": "2",
    className: "cb-location-detail-thirsty cb-color-red-900"
  }, "Breakfast All Day\xAE"))), /*#__PURE__*/React.createElement(Row, {
    className: "mt-16"
  }, /*#__PURE__*/React.createElement(Col, {
    className: width < 576 ? "d-flex justify-content-center" : "",
    xs: "12",
    lg: {
      span: 3,
      order: 2
    }
  }, /*#__PURE__*/React.createElement(ImageLoader, {
    media: width > 576 ? media2 : mobileMedia2,
    className: "cb-location-detail__image"
  })), /*#__PURE__*/React.createElement(Col, {
    xs: "12",
    lg: {
      span: 9,
      order: 3
    }
  }, /*#__PURE__*/React.createElement("p", {
    className: "cb-type-title-2 cb-color-red-900"
  }, "Enjoy an all day breakfast at your local Cracker Barrel. Choose a signature favorite such as Grandma's Sampler. Includes two Buttermilk Pancakes served with your own warm bottle of 100% Pure Natural Syrup, two eggs, one strip of Thick-Sliced Bacon, one Smoked Sausage Patty, and a sampling of Sugar Cured or Country Ham. Served with Hashbrown Casserole or Fried Apples."))), width > 576 ? /*#__PURE__*/React.createElement(Separator, {
    background: "default",
    display: "solid",
    image: true,
    padding: "medium"
  }) : /*#__PURE__*/React.createElement("br", null)), /*#__PURE__*/React.createElement(Col, {
    xs: "12",
    lg: {
      span: 7,
      order: 4
    },
    className: width > 896 ? "cb-column-gap-reduction-small" : ""
  }, /*#__PURE__*/React.createElement("h2", {
    "aria-level": "2",
    className: "cb-type-headline-1 cb-color-red-900"
  }, "JOIN OUR TEAM"), /*#__PURE__*/React.createElement("p", {
    className: "cb-type-title-2 cb-color-red-900 mt-16"
  }, "We are always looking for enthusiastic people to help us do what we do best \u2014 please our guests with great country cooking and friendly service."), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(Button, {
    className: "cb-button-primary",
    href: openJobsURL
  }, "View Open Jobs"), width > 576 ? /*#__PURE__*/React.createElement(Separator, {
    background: "default",
    display: "solid",
    image: true,
    padding: "medium"
  }) : null), /*#__PURE__*/React.createElement(Col, {
    xs: "12",
    lg: {
      span: 5,
      order: 5
    }
  }, /*#__PURE__*/React.createElement("h2", {
    "aria-level": "2",
    className: "cb-type-headline-1 cb-color-red-900"
  }, "Like us on Facebook"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("iframe", {
    src: facebookLike,
    width: "60",
    height: "65",
    scrolling: "no",
    frameBorder: "0",
    allowFullScreen: true,
    allow: "autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
  })), /*#__PURE__*/React.createElement(Col, {
    xs: "0",
    lg: {
      span: 5,
      order: 11
    }
  }), Boolean(Array.isArray(nearbyLocations) && nearbyLocations.length) && /*#__PURE__*/React.createElement(Col, {
    xs: "12",
    lg: {
      span: 7,
      order: 12
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "mt-16"
  }, /*#__PURE__*/React.createElement(Row, {
    className: "row-grid"
  }, /*#__PURE__*/React.createElement(Col, {
    lg: "5"
  }, /*#__PURE__*/React.createElement("div", {
    id: "nearbyMap",
    style: {
      height: 400 + 'px'
    }
  })), /*#__PURE__*/React.createElement(Col, {
    lg: "7"
  }, nearbyLocations.map(function (location, index) {
    var _schedule, _schedule$today;

    var directions = "https://maps.google.com/maps?q=Cracker+Barrel,+" + location.address1 + "+" + location.city + ",+" + location.state + "+" + location.zip;
    var directionsURL = directions.replace(/\s/g, "+");
    var details = "https://locations.crackerbarrel.com/" + location.state + "/" + location.city + "/" + location.storeNumber + "/";
    var detailsURL = details.replace(/\s/g, "-");
    var schedule = [{
      "open": location.sundayOpen,
      "close": location.sundayClose
    }, {
      "open": location.mondayOpen,
      "close": location.mondayClose
    }, {
      "open": location.tuesdayOpen,
      "close": location.tuesdayClose
    }, {
      "open": location.wednesdayOpen,
      "close": location.wednesdayClose
    }, {
      "open": location.thursdayOpen,
      "close": location.thursdayClose
    }, {
      "open": location.fridayOpen,
      "close": location.fridayClose
    }, {
      "open": location.saturdayOpen,
      "close": location.saturdayClose
    }];
    var today = getDay(new Date());
    var tomorrow = ((_schedule = schedule[today + 1]) === null || _schedule === void 0 ? void 0 : _schedule.open) || "";
    var closeHours = ((_schedule$today = schedule[today]) === null || _schedule$today === void 0 ? void 0 : _schedule$today.close) || "";

    var _closeHours$split = closeHours.split(':'),
        _closeHours$split2 = _slicedToArray(_closeHours$split, 2),
        _closeHours$split2$ = _closeHours$split2[0],
        hours = _closeHours$split2$ === void 0 ? "" : _closeHours$split2$,
        _closeHours$split2$2 = _closeHours$split2[1],
        minutes = _closeHours$split2$2 === void 0 ? "" : _closeHours$split2$2;

    var _minutes$split = minutes.split(' '),
        _minutes$split2 = _slicedToArray(_minutes$split, 2),
        _minutes$split2$ = _minutes$split2[0],
        minute = _minutes$split2$ === void 0 ? "" : _minutes$split2$,
        _minutes$split2$2 = _minutes$split2[1],
        meridian = _minutes$split2$2 === void 0 ? "" : _minutes$split2$2;

    hours = meridian === 'PM' ? parseInt(hours) + 12 : hours;
    var closing = new Date();
    closing.setHours(hours);
    closing.setMinutes(minute);
    closing.setSeconds(0);
    var open = differenceInMilliseconds(closing, new Date());
    var result = "";

    if (open > 0) {
      result = "Open until ".concat(closeHours);
    } else if (open <= 0) {
      result = "Opens at ".concat(tomorrow);
    }

    return /*#__PURE__*/React.createElement(Row, {
      key: index
    }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(LocationCard, {
      data: location,
      showHeader: true,
      isFinder: true
    }), /*#__PURE__*/React.createElement(Separator, {
      background: "default",
      display: "solid",
      image: true,
      topPadding: "none",
      bottomPadding: "none"
    })));
  }))), /*#__PURE__*/React.createElement("br", null))), /*#__PURE__*/React.createElement(Col, {
    xs: "0",
    lg: {
      span: 5,
      order: 9
    }
  }), /*#__PURE__*/React.createElement(Col, {
    xs: "12",
    lg: {
      span: 7,
      order: 10
    }
  })), /*#__PURE__*/React.createElement("br", null)));
};

var Service = function Service(_ref2) {
  var href = _ref2.href,
      media = _ref2.media,
      heading = _ref2.heading,
      body = _ref2.body,
      Available = _ref2.Available;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    className: "cb-location-detail__service"
  }, /*#__PURE__*/React.createElement("a", {
    href: href
  }, /*#__PURE__*/React.createElement(ImageLoader, {
    media: media,
    className: "cb-location-detail__image"
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
    href: href
  }, /*#__PURE__*/React.createElement("p", {
    className: "cb-type-subheading-1 cb-color-red-900"
  }, heading, !Available ? "- Currently Unavailable" : "")), /*#__PURE__*/React.createElement("p", {
    className: "cb-type-title-2 cb-color-red-900"
  }, body)))), /*#__PURE__*/React.createElement("br", null));
};

var TimeDisplay = function TimeDisplay(_ref3) {
  var num = _ref3.num,
      name = _ref3.name,
      times = _ref3.times;
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    lg: "3"
  }, /*#__PURE__*/React.createElement("p", {
    className: "cb-type-title-2 cb-color-red-900",
    style: getDay(new Date()) == num ? {
      fontWeight: 'bold'
    } : {
      fontWeight: 'normal'
    }
  }, name)), /*#__PURE__*/React.createElement(Col, {
    lg: "9"
  }, /*#__PURE__*/React.createElement("p", {
    className: "cb-type-title-2 cb-color-red-900",
    style: getDay(new Date()) == num ? {
      fontWeight: 'bold'
    } : {
      fontWeight: 'normal'
    }
  }, times)));
};